import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'bibibop-only-for-qa': {
    '/:brand/product': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'bbb/product_demo',
      },
    },
  },
}

export default demo
